import { Page } from '@acme/foundation';
import { adminApplicationListTabs } from '@entities/applicationList';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApplicationsListBreadcrumbs } from '../lib/breadcrumbs';
import { ApplicationList } from './list/applicationList';

export const ApplicationsListPage = () => {
  const navigate = useNavigate();

  const breadcrumbItems = useMemo(
    () => getApplicationsListBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <Page breadcrumbItems={breadcrumbItems}>
      <ApplicationList tabs={adminApplicationListTabs} />
    </Page>
  );
};
